import { Col, Row } from "react-bootstrap";
import BreadCrumbs from "./BreadCrumbs";
import AbstractionFields from "./AbstractionFields";
import { useParams } from "react-router-dom";
import Page404 from "../../../../pages/auth/Page404";

import useAppSelector from "../../../../hooks/useAppSelector";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { useState } from "react";

import Page500 from "../../../../pages/auth/Page500";

import {
  IAbstractionDetails,
  IAbstractionResponse,
} from "../../../../api/Abstractions/IAbstractions";
import { DocumentsGrid } from "./DocumentsGrid";
import {
  loadAbstractionAsync,
  selectAbstractionResponse,
} from "../../redux/slices/abstraction";
import Loading from "../../../../leap-components/Loading";
import ContactUs from "./ContactUs";

const IsAbstractionReady = (abstractionResponse?: IAbstractionResponse) => {
  if (!abstractionResponse) {
    return false;
  }

  if (abstractionResponse.response.httpStatusCode === 404) {
    return false;
  }

  if (!abstractionResponse.abstraction) {
    return false;
  }

  return true;
};

const GetNotReadyComponent = (abstractionResponse?: IAbstractionResponse) => {
  if (!abstractionResponse) {
    return <Loading />;
  }

  if (abstractionResponse.response.httpStatusCode === 404) {
    return <Page404 />;
  }

  if (!abstractionResponse.abstraction) {
    return <Page500 />;
  }

  return <Loading />;
};

const AbstractionDetails = () => {
  const [loading, setLoading] = useState(false);
  const abstractionSelector = useAppSelector(selectAbstractionResponse);
  const dispatch = useAppDispatch();

  let { regNo } = useParams();
  if (!regNo) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadAbstractionAsync(regNo));
  }

  if (!IsAbstractionReady(abstractionSelector.abstractionResponse)) {
    return GetNotReadyComponent(abstractionSelector.abstractionResponse);
  }

  const absDetails = abstractionSelector.abstractionResponse
    ?.abstraction as IAbstractionDetails;

  const contentElement = (
    <div>
      <Row>
        <Col className="ps-0">
          <AbstractionFields abstractionDetails={absDetails} />
        </Col>
      </Row>
      <Row>
        <Col className="ps-0">
          <DocumentsGrid licenseId={absDetails.licenceid} />
        </Col>
      </Row>
      <Row>
        <Col className="ps-0">
          <ContactUs />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs regno={absDetails.registernumber} />
      <div className="ps-0">{contentElement}</div>
    </div>
  );
};

export default AbstractionDetails;
